import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { Deposito } from 'src/app/shared/models/deposito';
import { Estado } from 'src/app/shared/models/estado';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';

import { UbicacionAlmacenamiento } from 'src/app/shared/models/ubicacionAlmacenamiento';
import { ConfigService } from 'src/app/shared/services/config.service';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { ParametrosService } from 'src/app/shared/services/parametros.service';

import { TablasService } from 'src/app/shared/services/tablas.service';
import { isMobile, isMobileXL, loadData } from 'src/app/shared/utils/helpers';
import { TransferenciaPlantaCabecera } from 'src/app/shared/models/transferenciaPlantaCabecera';
import { TransferenciaPlantaItem } from 'src/app/shared/models/transferenciaPlantaItem';
import { TPService } from 'src/app/shared/services/tp.service';

@Component({
  selector: 'app-tp-item-dialog',
  templateUrl: './tp-item-dialog.component.html'
})
export class TPItemDialogComponent {
  mensaje: number = 0;
  tpItemForm: FormGroup;
  idTipo: number;
  lp: ListaPrecioCabecera;

  codigoEdit: number = -1;
  
  precioFijo: boolean = false;
  tpCab: TransferenciaPlantaCabecera;
  // storagesLocations: UbicacionAlmacenamiento[] = [];
  // plantaItemSeleccionada: Deposito;
  // plantasItem: Deposito[] = [];
  // slSeleccionado: UbicacionAlmacenamiento;
  lotes: any[] = [];
  lSeleccionado: any;
  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string;
  constructor(

    private fb: FormBuilder,
    private configService: ConfigService,
    private loggedService: LoggedService,
    private dialogRef: MatDialogRef<TPItemDialogComponent>,
    private tpService: TPService,
    private tablasService: TablasService,
    private parametrosService: ParametrosService,

    @Inject(MAT_DIALOG_DATA) private data: any) {

    this.tpItemForm = this.fb.group({
      idEstado: [''],
      estado: [''],
      autor: [''],
      cantidad: [1,[Validators.required, Validators.min(0.001)]],
      cultivo: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      habilitacion: [true],
      idCompania: [''],
      idCultivo: [''],
      idDivision: [''],
      idLote: ['', Validators.required],
      idPais: [''],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      idTipoOrden: ['8'],
      idTipoEntrega: [''],
      tipoEntrega: [''],
      nroLinea: [0],
      nroPedido: [0],
      porcentajeRecargo: [0],
      precioFinal: [0],
      precioKGL: [0],
      precioUnitarioFinal: [0],
      precioUnitarioLista: [0],
      producto: ['', Validators.required],
      recargo: [0],
      recargoLocal: [0],
      tipoOrden: ['Trasferencia a Planta'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      fechaCreacion: [new Date()],
      idUbicacionAlmacenamiento: ['', Validators.required],
      idPlanta: ['', Validators.required],
      planta: [''],
      unidadesPallet: [0],
      codigo: [0]
    })
    if (data.cab != null) {
      this.tpCab = data.cab;
    }
  }
  public Validaciones: {
    Cantidad: string,
    PrecioFinal: string,
    MotivoRetencion: string
    IdLote: string;
  }

  public Etiquetas: {

    Cantidad: string,
    CantidadDisponible: string,
    IdProducto: string,
    Producto: string,
    PrecioUnitarioLista: string,
    PrecioUnitarioFinal: string,
    NroLinea: string,
    PrecioFinal: string,
    PrecioKGL: string,
    Planta: string,
    StorageLocation: string,
    IdLote: string;



  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Validaciones = {
      Cantidad: this.configService.validaciones.Cantidad,
      PrecioFinal: this.configService.validaciones.PrecioFinal,
      MotivoRetencion: this.configService.validaciones.MotivoRetencion,
      IdLote: this.configService.validaciones.IdLote,
    }

    this.Etiquetas = {
      PrecioFinal: this.configService.etiquetas.PrecioFinal,
      Cantidad: this.configService.etiquetas.Cantidad,
      CantidadDisponible: this.configService.etiquetas.CantidadDisponible,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      NroLinea: this.configService.etiquetas.NroLinea,
      IdProducto: this.configService.etiquetas.IdProducto,
      Planta: this.configService.etiquetas.IdPlanta,
      StorageLocation: this.configService.etiquetas.StorageLocation,
      IdLote: this.configService.etiquetas.Inventarios.IdLote,


    }
    if (this.tpCab != null) {
      
      if (this.tpCab.items.length) {
        loadData(this.tpItemForm, this.tpCab.items[0]);
        this.codigoEdit = this.tpCab.items[0].codigo;
      }

    }


    this.tpService.cTransferenciaPlantaItem(this.codigoEdit).subscribe((data: TransferenciaPlantaItem) => {

      if (data != null) {
        this.tpItemForm.controls['cantidad'].setValue(data.cantidad);
        this.tpItemForm.controls['idProducto'].setValue(data.idProducto);
        this.tpItemForm.controls['nroLinea'].setValue(data.nroLinea);
        this.tpItemForm.controls['precioFinal'].setValue(data.precioUnitarioFinal);
        this.tpItemForm.controls['precioKGL'].setValue(data.precioKGL);
        this.tpItemForm.controls['precioUnitarioFinal'].setValue(data.precioUnitarioFinal);
        this.tpItemForm.controls['precioUnitarioLista'].setValue(data.precioUnitarioLista);
        this.tpItemForm.controls['producto'].setValue(data.producto);
        this.tpItemForm.controls['idPlanta'].setValue(data.idPlanta);
        this.tpItemForm.controls['idUbicacionAlmacenamiento'].setValue(data.idUbicacionAlmacenamiento);
        this.tpItemForm.controls['unidadesPallet'].setValue(data.unidadesPallet);

      }
      forkJoin([

        // this.tablasService.cPlantas(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
        // this.tpService.cStoragesLocationsPlanta(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
        this.tpService.cTransferenciasLotes(this.tpItemForm.controls['idPais'].value, this.tpItemForm.controls['idCompania'].value, this.tpItemForm.controls['idSalesOrg'].value, this.tpItemForm.controls['idProducto'].value, this.tpCab.idSucursal)
      ]).subscribe((data: [any[]]) => {


        // if (data[0].length) {

        //   this.plantasItem = data[0];

        // }
        // if (data[1].length) {

        //   this.storagesLocations = data[1];

        // }
        if (data[0].length) {

          this.lotes = data[0];

        }
      });
    });


  }

  guardarItem() {
    if (this.tpItemForm.controls['unidadesPallet'].value == 0) {
      this.avisoUnidadesPallet = true
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto"
    }
    else {

      const cantidadNum = this.tpItemForm.controls['cantidad'].value;
      const unidadesPallet = this.tpItemForm.controls['unidadesPallet'].value
      var esMultiplo =  Math.abs(cantidadNum / unidadesPallet - Math.round(cantidadNum / unidadesPallet)) < 1e-10;
      let valornum = cantidadNum / unidadesPallet

      if (!esMultiplo) {
        this.avisoUnidadesPallet = true;
        valornum = Math.floor(valornum) + 1
this.mensajeUnidadesPallet = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
          + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó " 
          + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
      } else {
        this.avisoUnidadesPallet = false;
      }
    }
    if (!this.avisoUnidadesPallet) {
    this.tpCab.items = [];
    this.tpCab.items.push(this.tpItemForm.value);

    this.tpService
      .mTransferenciaPlantaItem(this.tpCab)
      .subscribe((data: boolean) => {
        this.mensaje = 2;
        this.dialogRef.close();
      });
    }
  }
  checkPrecioFinal() {
    if (this.tpItemForm.controls['precioFinal'].value == null || (this.tpItemForm.controls['precioFinal'].value != null && this.tpItemForm.controls['precioFinal'].value == '')) {
      this.tpItemForm.controls['precioFinal'].setValue(0);
    }
  }

  // seleccionarPlantaItem(pI: any) {

  //   this.storagesLocations = []
  //   this.plantaItemSeleccionada = null;
  //   if (pI != null) {
  //     this.plantaItemSeleccionada = this.plantasItem.find(c => c.idPlanta == pI);
  //     if (this.plantaItemSeleccionada != null) {
  //       this.tpItemForm.controls['planta'].setValue(this.plantaItemSeleccionada.descripcion);

  //       this.tpService
  //         .cStoragesLocationsPlanta(this.plantaItemSeleccionada.idPais, this.plantaItemSeleccionada.idCompania, this.plantaItemSeleccionada.idSalesOrg, this.plantaItemSeleccionada.idPlanta)
  //         .subscribe((data: UbicacionAlmacenamiento[]) => {

  //           if (data != null) {
  //             this.storagesLocations = data;

  //           }

  //         })

  //     }
  //   }
  //   else {
  //     this.tpItemForm.controls['planta'].reset();
  //     this.tpItemForm.controls['idPlanta'].reset();

  //   }

  // }

  // seleccionarStorageLocation(sl: any) {

  //   this.slSeleccionado = null;
  //   if (sl != null) {
  //     this.slSeleccionado = this.storagesLocations.find(c => c.id == this.tpItemForm.controls['idUbicacionAlmacenamiento'].value);
  //   }

  // }

  seleccionarLote(l: any) {

    this.lSeleccionado = null;
    if (l != null) {
      this.lSeleccionado = this.lotes.find(c => c.id == this.tpItemForm.controls['idLote'].value);
    } else {
      this.tpItemForm.controls['idLote'].reset();
    }
  }
  
  // comparePlantas(pLista: any, pPAI: any): boolean {
  //   return pLista === pPAI;
  // }

  // compareStoragesLocations(slLista: any, slPAI: any): boolean {
  //   return slLista === slPAI;
  // }
  compareLotes(lLista: any, lTP: any): boolean {
    return lLista === lTP;
  }
  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
